module.exports = __webpack_public_path__ + "img/logo.cc086ba8.svg";